<div class="flex items-center gap-4 px-6 pt-6 pb-5 border-b border-outline-variant">
  <div class="flex items-center justify-center w-10 h-10 rounded-full bg-error-container shrink-0">
    <mat-icon class="text-on-error-container text-[20px]! w-5! h-5!">warning</mat-icon>
  </div>
  <div>
    <h2 class="text-lg font-medium leading-tight">Neuložené změny</h2>
    <p class="text-sm text-on-surface-variant mt-0.5">Provedené změny nebudou uloženy</p>
  </div>
</div>

<!-- Material zeroes the content's bottom padding when the dialog has actions. -->
<mat-dialog-content class="pb-5!">
  <p class="text-sm">
    Máte neuložené změny. Opravdu chcete tuto stránku opustit? Provedené změny budou ztraceny.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" class="border-t border-outline-variant!">
  <button matButton (click)="dialogRef.close(false)">Zůstat na stránce</button>
  <button matButton="filled" class="bg-error! text-on-error!" (click)="dialogRef.close(true)">
    Opustit bez uložení
  </button>
</mat-dialog-actions>
